export default __webpack_public_path__ + "static/media/PLU-BEERCARD-A4-5-bckg-1.a645c07c.jpg";